import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { useModal } from 'flow/contexts/ModalProvider';
import { removeAllVoiceMessages } from 'flow/actions/extension-actions';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import Button from 'flow/components/ui-components/Button';

const ButtonDeleteAllVoicemails = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    return (
        <div className="p-3">
            <Button
                className="w-full"
                color="danger"
                onClick={() =>
                    openModal('removeDialog', {
                        title: i18next.t('call.voicemail.delete.title'),
                        description: i18next.t(
                            'call.voicemail.remove.question',
                        ),
                        onRemove: () =>
                            dispatch(removeAllVoiceMessages(ownExtensionKey)),
                    })
                }
            >
                {i18next.t('call.voicemail.delete.title')}
            </Button>
        </div>
    );
};

export default ButtonDeleteAllVoicemails;
